import { SkyscannerExploreexperiencessvcV1Experiences } from '@skyscanner-internal/explore-experiences-svc-web-http-client';

import { grpcFetchClientWrapperNoHeaders } from '../../internals/clients/grpc/grpc';

export const GRPC_EXPLORE_EXPERIENCES_CLIENT_NAME = 'EXPLORE_EXPERIENCES_GET_EXPERIENCES';
export const GRPC_EXPLORE_EXPERIENCES_DOLPHINS_CLIENT_NAME = 'EXPLORE_EXPERIENCES_GET_DOLPHINS';
export const PATH_PREFIX = '/g/explore-experiences-svc';

export const getExperiences = grpcFetchClientWrapperNoHeaders(
  SkyscannerExploreexperiencessvcV1Experiences.ExperiencesService.GetExperiences,
  {
    clientName: GRPC_EXPLORE_EXPERIENCES_CLIENT_NAME,
    pathPrefix: PATH_PREFIX,
  },
);

export const getDolphins = grpcFetchClientWrapperNoHeaders(
  SkyscannerExploreexperiencessvcV1Experiences.ExperiencesService.GetMiamiDolphins,
  {
    clientName: GRPC_EXPLORE_EXPERIENCES_DOLPHINS_CLIENT_NAME,
    pathPrefix: PATH_PREFIX,
  },
);
